<template>
    <div class="initiatives-article-footer d-flex flex-column justify-center align-center mt-50">
        <template v-if="project.articles.length > 1">
          <router-link class="mt-16 mb-2 link" :to="{name: 'InitiativesDetails', params:{slug: this.project._slug}}">{{$root.siteSettings.backToTheInitiativeLabel}}</router-link>
          <hr/>
          <h3 class="mt-8 mb-16">{{project.name}}</h3>
        </template>
        <template v-else>
          <router-link class="mt-16 mb-2 link" :to="{name: 'Initiatives'}">{{$root.siteSettings.backToTheInitiativeLabel}}</router-link>
          <hr/>
          <h3 class="mt-8 mb-16">{{$root.siteSettings.initiativesPageTitle}}</h3>
        </template>

    </div>
</template>

<script>
export default {
  name: 'InitiativesArticleFooter',
  props: {
    project: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.mt-50 {
  margin-top: 200px;
}

.initiatives-article-footer {
  background-color: map-get(map-get($material-light, 'text'), 'primary');
  color: map-get(map-get($material-light, 'text'), 'secondary');
  max-height: 320px;
  padding: 98px 30px;

  hr {
    width: 50px;
    border-color: $c-pink;
  }

  .link {
    color: $c-pink;
  }

  h3 {
    font-size: 5.5vh;
  }
}
</style>
